import { AppDispatch, RootState } from "../reducers/store";
import { Group } from "../model/group";
import { useDispatch, useSelector } from 'react-redux';
import { CardActionArea, CardContent, Typography, Grid2, Box, CardActions, Button, IconButton, Divider } from "@mui/material";
import { getGroupsAsync, setCurrentGroup } from "../reducers/groupSlice";
import { getApiAccessToken } from "../auth/auth";
import { deleteGroup, getGroups, getGroupUsers } from "../api/groups";
import { ClientInputs } from "./clientinputs";
import { AxiosError } from "axios";
import { useMsal } from "@azure/msal-react";
import Card from "@mui/material/Card";
import { AlertView } from "./alert";
import { useState } from "react";
import { Loader } from "./loader";
import { DeleteDialog } from "./deleteconfirm";
import { setFirstProgramInGroup } from "../reducers/programSlice";
import { getUserRole } from "../auth/jwt";

export const ClientView = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const dispatch: AppDispatch = useDispatch();

    const currentGroup: Group | null = useSelector((state: RootState) => state.groups.currentGroup);
    const groups: Group[] = useSelector((state: RootState) => state.groups.groups);
    
    const [errorMessage, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    let userRole = getUserRole(activeAccount);
    if (userRole == null) {
        return (
            <div className="container">
                <div className="centered-box">
                    <AlertView error={"You do not have access to any programs."}/>
                </div>
            </div>
        );
    }
    
    const reloadGroups = async () => {
        try {
            let accessToken = await getApiAccessToken(instance, activeAccount)
            
            dispatch(getGroupsAsync({accessToken}))
            setLoading(false)

        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error)
            } else if (error instanceof Error) {
                console.error(error);
            }
            setLoading(false)
        }
    }

    const handleSelected = async (group: Group) => {
        dispatch(setCurrentGroup(group))
        dispatch(setFirstProgramInGroup(group));
    }

    const handleDelete = async (group: Group | null) => {
        if (!group) {
            setError("No client selected for which to delete the user")
            return
        }

        try {            
            setLoading(true)
            let accessToken: string = await getApiAccessToken(instance, activeAccount)
            await deleteGroup(accessToken, group.id);

            if (group.id == currentGroup?.id) {
                let notDeletedGroup = groups.find(group => group.id != currentGroup.id)
                if (notDeletedGroup) {
                    dispatch(setCurrentGroup(notDeletedGroup))
                }
            }

            reloadGroups()

        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error)
                setError(error?.message)
            } else if (error instanceof Error) {
                console.error(error);
            }
            setLoading(false)
        }

    }

    return (
        <>
            <Box sx={{  display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                <Typography variant="h6" sx={{ margin: 2}}>Clients</Typography>
                <AlertView error={errorMessage} />
                <ClientInputs onAdded={() => {reloadGroups()}}/>
                {
                    loading ? <Loader/> :
                    [...groups]
                    .sort((groupA, groupB) => groupA.displayName.localeCompare(groupB.displayName))
                    .map((group) => {
                        return(
                            <Card 
                                key={group.id} 
                                elevation={group.id == currentGroup?.id ? 12 : 0}
                                color="secondary"
                                variant={ group.id == currentGroup?.id ? "elevation" : "outlined"} 
                                sx={{ 
                                    width: 200, 
                                    height: 200, 
                                    margin: 2
                                }}>
                                <CardActionArea 
                                    sx={{ width: 200, height: 150}} 
                                    onClick={() => {handleSelected(group)}}>
                                    <CardContent>
                                        <Typography gutterBottom component="div">
                                            {group?.displayName}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                                <Divider />
                                <CardActions sx={{ width: 200, height: 50, justifyContent: 'space-between'}} >
                                    <Button 
                                        onClick={() => {handleSelected(group)}}
                                        size="small" 
                                        color="primary">
                                            Select
                                    </Button>
                                    <DeleteDialog 
                                        title={`Delete ${group.displayName}`}
                                        message={`Are you sure you want to delete this client?`} 
                                        onDeleteConfirmed={() => {handleDelete(group)}}
                                    />
                                </CardActions>
                            </Card>
                        )
                    })
                }
            </Box>
        </>
    )
}